var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as Sentry from "@sentry/browser";
import { Scope } from "@sentry/react";
import { logger } from "../helpers/logger.helper";
import { PerformanceSentry } from "./sentry/performance.sentry";
var client;
var tags = new Map();
var performanceCaptured = false;
var SentryProvider = {
    tag: {
        set: function (key, value) {
            tags.set(key, value);
        },
        remove: function (key) {
            tags.delete(key);
        },
        clear: function () {
            tags.clear();
        },
    },
    init: function (dsn, sentryEnvironment, gitTag, sentryTunnelUrl) {
        logger.log("SentryProvider", "Init");
        if (dsn === undefined || dsn.length === 0)
            return;
        client = Sentry.init({
            dsn: dsn,
            autoSessionTracking: true,
            environment: sentryEnvironment,
            release: gitTag,
            normalizeDepth: 0,
            tracesSampleRate: 1.0,
            tunnel: sentryTunnelUrl,
            integrations: [
                Sentry.browserTracingIntegration({
                    instrumentPageLoad: false,
                    instrumentNavigation: false,
                }),
            ],
            beforeBreadcrumb: function (breadcrumb, _) {
                return breadcrumb;
            },
            beforeSendSpan: function (span) {
                return span;
            },
            beforeSendTransaction: function (event, _) {
                return event;
            },
        });
    },
    getTagsEntries: function () {
        return tags.entries();
    },
    getClient: function () {
        return client;
    },
    startNewTrace: function (callback) {
        if (client == null)
            return console.error("Sentry client not initialized");
        return Sentry.startNewTrace(callback);
    },
    startTransaction: function (spanOptions, spanCallback) {
        if (client == null)
            return console.error("Sentry client not initialized");
        return Sentry.startSpanManual(spanOptions, spanCallback);
    },
    captureError: function (error, errorInfo, scope) {
        var e_1, _a;
        if (scope === void 0) { scope = new Scope(); }
        logger.log("SentryProvider", "CaptureError", error, errorInfo);
        try {
            for (var _b = __values(tags.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                scope.setTag(key, value);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        scope.setExtra("stack", error);
        if (client == null)
            return console.error("Sentry client not initialized");
        return client.captureException(error, undefined, scope);
    },
    performanceTrackNavigation: function (viewName, performanceSince) {
        if (performanceSince === void 0) { performanceSince = performance.now(); }
        if (performanceCaptured) {
            this.performanceCapture(viewName, performanceSince);
            return;
        }
        performanceCaptured = true;
        this.performanceCapture(viewName, 0);
    },
    performanceCapture: function (viewName, performanceSince) {
        if (client == null)
            return console.error("Sentry client not initialized");
        var isPageLoad = performanceSince === 0;
        if (isPageLoad === false)
            return; // TODO for now is Navigation sampling disabled
        var platformSlug = "";
        if (tags.has("platform")) {
            platformSlug = " ".concat(tags.get("platform"), " - ").concat(viewName);
        }
        new PerformanceSentry(platformSlug).capturePageLoad();
    },
    performanceAction: function (actionName, performanceSince) {
        if (client == null)
            return console.error("Sentry client not initialized");
        var platformSlug = "";
        if (tags.has("platform")) {
            platformSlug = " ".concat(tags.get("platform"), " - ").concat(actionName);
        }
        new PerformanceSentry(platformSlug).captureAction(performanceSince);
    },
};
export { SentryProvider };
//# sourceMappingURL=sentry.provider.js.map